import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { NavBar } from "./components/NavBar";
import "./styles/style.css";

export const TelcoLanding = () => {
  return (
    <Container style={{ maxWidth: "100%" }}>
      <NavBar />
      <Container fluid className="main-banner">
        <Container>
          <Row>
            <Col xl={5} lg={6} md={9}>
              <h2 className="title">Journey With Fast Internet</h2>
              <p className="wow">
                Fast Speed + No Service Charge + No Contracts + Powerful
                Coverage
              </p>
              <div className="banner-price">
                <h3
                  className="price"
                  style={{
                    fontSize: "60px",
                    fontWeight: "1000",
                    lineHeight: "54px",
                    textSizeAdjust: "100%",
                  }}
                >
                  $25.00<sub>/Month</sub>
                </h3>
                <a href="#prices">
                  <Button
                    variant={"danger"}
                    style={{
                      fontWeight: "1000",
                      margin: "40px 0",
                      padding: "20px 20px",
                      width: "170px",
                      borderRadius: "20px",
                      backgroundColor: "#df0e0e",
                    }}
                  >
                    Choose plan
                  </Button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="pricing-area pt-110 pb-90">
        <Container>
          <Row>
            <Col>
              <div
                className="section-title text-center"
                style={{ marginBottom: "50px" }}
              >
                <h2 className="title">Discover Our Prepaid Card Deals</h2>
              </div>
            </Col>
          </Row>
          <div id="prices" className="pricing-plan-wrap">
            <Row>
              <Col>
                <div className="pricing-item" style={{ marginBottom: "30px" }}>
                  <Row className="pricing-thumb">
                    <Col className="flex-column justify-content-center align-items-center text-left">
                      <h3 className="title">10 GB</h3>
                      <h5 className="sub-title">Internet</h5>
                    </Col>
                  </Row>
                  <div className="pricing-content">
                    <ul className="pricing-list">
                      <li>Unlimited Calls</li>
                      <li>100 SMS</li>
                    </ul>
                    <div className="price-wrap">
                      <span> Start From </span>
                      <h3 className="price">
                        $25<sub>/Month</sub>
                      </h3>
                    </div>
                    <div className="pricing-btn">
                      <a
                        className="btn btn-link hover-underline"
                        href="/telco/checkout"
                      >
                        Find more
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className="col-lg-4 col-md-6 col-sm-9">
                <div className="pricing-item mb-30">
                  <Row className="pricing-thumb">
                    <Col className="flex-column justify-content-center align-items-center text-left">
                      <h3 className="title">20 GB</h3>
                      <h5 className="sub-title">Internet</h5>
                    </Col>
                  </Row>
                  <div className="pricing-content">
                    <ul className="pricing-list">
                      <li>Unlimited Calls</li>
                      <li>1000 SMS</li>
                    </ul>
                    <div className="price-wrap">
                      <span> Start From </span>
                      <h3 className="price">
                        $35<sub>/Month</sub>
                      </h3>
                    </div>
                    <div className="pricing-btn">
                      <a
                        className="btn btn-link hover-underline"
                        href="/telco/checkout"
                      >
                        Find more
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className="col-lg-4 col-md-6 col-sm-9">
                <div className="pricing-item mb-30">
                  <Row className="pricing-thumb">
                    <Col className="flex-column justify-content-center align-items-center text-left">
                      <h3 className="title">50 GB</h3>
                      <h5 className="sub-title">Internet</h5>
                    </Col>
                  </Row>
                  <div className="pricing-content">
                    <ul className="pricing-list">
                      <ul className="pricing-list">
                        <li>2 GB Roaming</li>
                        <li>Calls</li>
                      </ul>
                    </ul>
                    <div className="price-wrap">
                      <span> Start From </span>
                      <h3 className="price">
                        $55<sub>/Month</sub>
                      </h3>
                    </div>
                    <div className="pricing-btn">
                      <a
                        className="btn btn-link hover-underline"
                        href="/telco/checkout"
                      >
                        Find more
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </Container>
    </Container>
  );
};
